type TAnyFunction = (...args: any[]) => void;

const isOverflowed = (rect: DOMRect, containerRect: DOMRect) =>
    rect.top < containerRect.top ||
    rect.bottom > containerRect.bottom ||
    rect.left < containerRect.left ||
    rect.right > containerRect.right;

const parseStyleValue = (styleValue: string): number => parseInt(styleValue || '0', 10);

const getMaxElement = (side: 'bottom' | 'right', elements: NodeListOf<HTMLElement>) => {
    const values = Array.from(elements).map(node => {
        if (node.offsetHeight < node.scrollHeight || node.offsetWidth < node.scrollWidth) return 0;

        const style = document.defaultView?.getComputedStyle(node, null) ?? ({} as CSSStyleDeclaration);
        if (style['display'] === 'none') return 0;
        if (style['visibility'] === 'hidden') return 0;

        const rect = node.getBoundingClientRect();

        if (!!node.parentElement && node.parentElement !== document.body && style['position'] !== 'absolute') {
            const parentRect = node.parentElement.getBoundingClientRect();
            if (!!parentRect && isOverflowed(rect, parentRect)) return 0;
        }

        return rect[side] + parseStyleValue(style[side === 'bottom' ? 'marginBottom' : 'marginRight']);
    });

    return Math.max(...values);
};

const getAllElements = (): NodeListOf<HTMLElement> => document.querySelectorAll('body *');

export const getHeight = () => {
    const style = document.defaultView!.getComputedStyle(document.body, null) ?? {};
    const marginTop = parseStyleValue(style['marginTop']);
    const marginBottom = parseStyleValue(style['marginBottom']);
    const bodyOffsetHeight = document.body.offsetHeight + marginTop + marginBottom;

    const documentElementOffsetHeight = document.documentElement.offsetHeight;

    return Math.max(bodyOffsetHeight || documentElementOffsetHeight, getMaxElement('bottom', getAllElements()));
};

export const getWidth = () => getMaxElement('right', getAllElements());

export const getNow = Date.now || new Date().getTime;

export const debounce = (fn: Function, timeout = 100) => {
    let timeoutId: ReturnType<typeof setTimeout>;
    return function (this: any, ...args: any[]) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), timeout);
    };
};
